import EditUserContainer from "./EditUserContainer";

export default EditUserContainer;